const provinceCenters = {
  1: [37.557642, 45.076124], // آذربایجان غربی - ارومیه
  2: [38.069717, 46.307935], // آذربایجان شرقی - تبریز
  3: [38.236023, 48.297029], // اردبیل - اردبیل
  4: [37.271867, 49.582798], // گیلان - رشت
  5: [36.85, 53.05], // مازندران - ساری
  6: [36.83, 54.43], // گلستان - گرگان
  7: [37.439974, 57.195382], // خراسان شمالی - بجنورد
  8: [35.366656, 46.982675], // کردستان - سنندج
  9: [36.633162, 48.474622], // زنجان - زنجان
  10: [36.279707, 50.011345], // قزوین - قزوین
  11: [35.84, 50.94], // البرز - کرج ✅
  12: [35.69, 51.42], // تهران - تهران
  13: [35.583618, 53.39187], // سمنان - سمنان
  14: [36.297418, 59.570606], // خراسان رضوی - مشهد
  15: [34.343436, 47.053088], // کرمانشاه - کرمانشاه
  16: [34.83635, 48.511776], // همدان - همدان
  17: [34.429567, 49.610528], // مرکزی - اراک
  18: [34.642247, 50.886739], // قم - قم
  19: [33.137551, 46.86838], // ایلام - ایلام
  20: [33.513919, 48.352429], // لرستان - خرم‌آباد
  21: [32.68562, 51.670009], // اصفهان - اصفهان
  22: [32.861132, 59.206778], // خراسان جنوبی - بیرجند
  23: [31.32, 48.67], // خوزستان - اهواز
  24: [32.138409, 50.824018], // چهارمحال و بختیاری - شهرکرد
  25: [30.619005, 51.428043], // کهگیلویه و بویراحمد - یاسوج
  26: [31.905541, 54.374781], // یزد - یزد
  27: [28.724313, 51.13097], // بوشهر - بوشهر
  28: [29.616446, 52.549371], // فارس - شیراز
  29: [29.916852, 57.396807], // کرمان - کرمان
  30: [27.049342, 54.977306], // هرمزگان - بندرعباس
  31: [28.139816, 60.792176], // سیستان و بلوچستان - زاهدان
};
export default provinceCenters;
